import React from 'react'
import { Tooltip, Typography } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { EDeliveryRestriction } from 'models/product'
import {
  DELIVERY_RESTRICTIONS,
  YANDEX_PROHIBITED_GOODS_URL
} from 'shared/constants/deliveryRestrictions'

import styles from '../ProductForm.module.scss'

interface IDeliveryRestrictionNoteProps {
  restriction: EDeliveryRestriction
}

export const DeliveryRestrictionNote: React.FC<
  IDeliveryRestrictionNoteProps
> = ({ restriction }) => {
  const { label, section, quote } = DELIVERY_RESTRICTIONS[restriction]

  return (
    <div className={styles.deliveryRestriction}>
      <Typography.Text type='warning'>
        Товар не будет доступен для доставки в ПВЗ Яндекса и 5Post
      </Typography.Text>
      <Tooltip
        overlayStyle={{ maxWidth: 420 }}
        title={
          <div>
            <p>
              Причина: «{label}» — Яндекс Доставка не принимает такие товары.
              При оформлении заказа с ним эти пункты будут показаны недоступными.
            </p>
            <p>
              <a
                href={YANDEX_PROHIBITED_GOODS_URL}
                target='_blank'
                rel='noreferrer'
              >
                Правила Яндекс Доставки
              </a>
              , раздел «{section}»: «{quote}»
            </p>
          </div>
        }
      >
        <QuestionCircleOutlined className={styles.deliveryRestrictionHint} />
      </Tooltip>
    </div>
  )
}
